package com.cybersoftsolution.cybersoftsolutionweb.components.sections


import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.cards.ServiceCard
import com.cybersoftsolution.cybersoftsolutionweb.components.carousel.MyHorizontalCarousel
import com.cybersoftsolution.cybersoftsolutionweb.components.layouts.ContentLayout
import com.cybersoftsolution.cybersoftsolutionweb.models.Service
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.px


@Composable
fun ServiceSection(
    pageSection: PageSection,
    services:List<Service>,
    sectionModifier: Modifier = Modifier,
    contentModifier: Modifier = Modifier,
    title: String? = null,
) {

    val breakpoint = rememberBreakpoint()
//    val fixWithInPercent:Int by remember { mutableStateOf( floor(100f / services.size).toInt()) }
//    var responsiveWidth:Int by remember { mutableStateOf( 500 ) }

    var mutableServices by remember { mutableStateOf(services) }

    //Pause slideShow when a service is selected
    var pausedSlideShow:Boolean by remember { mutableStateOf( false ) }
    LaunchedEffect(mutableServices){
        pausedSlideShow = mutableServices.any { it.selected }
    }


    ContentLayout(
        title = title,
        pageSection = pageSection,
        sectionModifier = sectionModifier,
        contentModifier = contentModifier
    ){


        if (!isDesktop()) {



//            BootstrapCarousel(
//                modifier = Modifier
//                    .fillMaxWidth()
//
//                ,
//                darkMode = true,
//                id = pageSection.id+"carousel",
//                elements = mutableServices,
//                slideShow = true,
//            ) { service ->
//
//                ServiceCard(
//                    onCardClick = {
//                        val updateServices = mutableServices.map {
//                            if (it.id == service.id) {
//                                it.copy(selected = !it.selected)
//                            } else {
//                                it.copy(selected = false)
//                            }
//                        }
//                        mutableServices = updateServices
//                    },
//                    selected = service.selected,
//                    id = service.id+"CardInCarousel",
//                    serviceName = service.name,
//                    serviceDescription = service.description,
//                    serviceItems = service.items,
//                    serviceImage = service.image,
//                    onButtonClick = {},
//                    buttonText = "",
//                ){
//
//                }
//
//            }


            MyHorizontalCarousel(
                modifier = Modifier
                    .fillMaxWidth(),
                id = pageSection.id+"carousel",
                elements = mutableServices,
                slideDurationInSeconds = 5,
                slideShow = true,
                pauseSlideShow = pausedSlideShow,
                onForceToContinue = {
                    val updateServices = mutableServices.map { it.copy(selected = false)}
                    mutableServices = updateServices
                },
                initIndex = 1 + mutableServices.indexOfFirst { it.selected },
                previewButtonText = "\u279c",
                nextButtonText = "\u279c",
//                previewButtonText = "Anterior",
//                nextButtonText = "Siguiente",
//                    onResponsiveWidthChange = { responsiveWidthFromCarousel ->
//                        responsiveWidthFromCarousel?.let { responsiveWidth = it }
//                    }
            ) { service ->

                ServiceCard(
                    onCardClick = {
                        val updateServices = mutableServices.map {
                            if (it.id == service.id) {
                                it.copy(selected = !it.selected)
                            } else {
                                it.copy(selected = false)
                            }
                        }
                        mutableServices = updateServices
                    },
                    selected = service.selected,
                    id = service.id+"CardInCarousel",
                    serviceName = service.name,
                    serviceDescription = service.description,
                    serviceItems = service.items,
                    serviceImage = service.image,
                    onButtonClick = {},
                    buttonText = "",
                ){

                }
            }



        }
        else {
            pausedSlideShow = false

            Row(
                modifier = Modifier
                    .fillMaxWidth()
            ) {
                mutableServices.forEach { service ->


                    ServiceCard(
                        modifier = Modifier
                            .margin(leftRight = 8.px),
                        onCardClick = {
                            val updateServices = mutableServices.map {
                                if (it.id == service.id) {
                                    it.copy(selected = !it.selected)
                                } else {
                                    it.copy(selected = false)
                                }
                            }
                            mutableServices = updateServices
                        },
                        selected = service.selected,
                        id = service.id+"CardInRow",
                        serviceName = service.name,
                        serviceDescription = service.description,
                        serviceItems = service.items,
                        serviceImage = service.image,
                        onButtonClick = {},
                        buttonText = "",
                    ){

                    }




                }


            }

        }


    }


}